<template>
  <NuxtLayout
    name="main-view"
    :hasBackButton="true"
    :headline="$t('dbc-label-payment-method')"
  >
    <div
      v-if="successMessage"
      class="grid grid-cols-card-layout gap-2xs max-tablet:flex max-tablet:flex-col"
    >
      <DbcBanner
        severity="success"
        :has-border="true"
        :message="successMessage"
        :life="3000"
        class="mb-xs"
        role="alert"
        aria-live="assertive"
        @life-end="removeUpdateQueryParam()"
      />
    </div>
    <CardEdit
      v-if="paymentData && paymentData.paymentMethod"
      :title="$t(`dbc-label-${paymentData.paymentMethod.toLowerCase()}`)"
      :subtitle="subtitle"
      class="max-w-fit"
      @edit="
        $router.push({
          path: usePagePath('payment-update'),
        })
      "
    />
    <DbcBanner
      v-else-if="!isLoadingContracts"
      severity="warn"
      :has-border="true"
      :message="$t('dbc-error-no-valid-payment-data')"
      class="max-w-fit max-mobile:max-w-full"
      role="alert"
    />
  </NuxtLayout>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'
import { useCustomerStore } from '../../../../stores/customer'

const customerStore = useCustomerStore()
const { paymentData, isLoadingContracts } = storeToRefs(customerStore)

const { t } = useI18n()

const subtitle = ref<string>('')

formatPaymentData()

watch(paymentData, () => {
  formatPaymentData()
})

function formatPaymentData() {
  if (paymentData.value?.creditCardPayment) {
    const validTo = dayjs(
      paymentData.value?.creditCardPayment.creditCardValidTo
    ).format('MM/YY')
    subtitle.value = `${paymentData.value.creditCardPayment.creditCardProviderBrand.toUpperCase()} | ${
      paymentData.value?.creditCardPayment.creditCardNo
    } | ${validTo}`
  } else if (paymentData.value?.sepaDirectDebitPayment) {
    subtitle.value = `${paymentData.value.sepaDirectDebitPayment.accountHolder} | ${paymentData.value.sepaDirectDebitPayment.iban}`
  }
}

const route = useRoute()
const successMessage = ref('')
if (route.query.update) {
  successMessage.value = `${t(`dbc-label-${route.query.update}`)} ${t(
    'dbc-text-successfully-changed'
  )}`
}
</script>
